import * as ng from 'angular';

ng.module('e360')
   .factory('errorInterceptor', errorInterceptorFactory);

errorInterceptorFactory.$inject = ['$q', 'loader', 'toast'];
export function errorInterceptorFactory($q:ng.IQService, loader, toast) {
   return {
      responseError: responseError
   };

   function responseError(rejection: ng.IHttpPromiseCallbackArg<any>): any {
      if (rejection.status >= 500) {
         loader.hide();

         let message = [
            'An application error occurred on this request, our team has',
            'logged the event and will work to resolve it soon.',
            'We apologize for this inconvenience.'
         ].join(' ');

         toast.error().message(message).send();
      } else if (rejection.status == 403) {
         loader.hide();

         let message = 'Access to this resource has been denied.';

         toast.error().message(message).send();
      }

      return $q.reject(rejection);
   }
}
